import { Link, useLocation } from "@tanstack/react-router";

import { SideNav, type SideNavItem } from "@/components/ui/SideNav";

import { ADMIN_TOOLS } from "./adminTools";

const NAV_ITEMS: SideNavItem[] = [
  { href: "/admin", label: "Hub", match: "exact" },
  ...ADMIN_TOOLS.map((tool) => ({
    href: tool.href,
    label: tool.label,
    match: (tool.match ?? "prefix") as "exact" | "prefix",
  })),
];

type AdminBackOfficeNavProps = {
  className?: string;
};

export default function AdminBackOfficeNav({ className }: AdminBackOfficeNavProps) {
  const { pathname } = useLocation();

  return (
    <SideNav
      items={NAV_ITEMS}
      pathname={pathname}
      label="Developer back office"
      className={className}
      data-testid="admin-back-office-nav"
    />
  );
}
